import { effect } from '@angular/core';
import { getState, signalStoreFeature, withHooks } from '@ngrx/signals';

/**
 * NGRX signal store feature which prints on the console everytime the store's state changes.
 *
 * @param name The name of the logger
 */
export function withLogger(name: string) {
    return signalStoreFeature(
        withHooks({
            onInit(store) {
                effect(() => {
                    console.group('NGRX ' + name);

                    const state = getState(store);
                    console.log('Current state', state);

                    console.groupEnd();
                });
            },
            onDestroy() {
                console.group('NGRX ' + name + ' destroyed!');
                console.groupEnd();
            },
        })
    );
}
